import { blogPosts } from "../client/src/data/blog";

// Deliberately independent of the tracking allowlist. Public != safe to snapshot:
// signup, auth, tokens, checkout and confirmations must never enter this list.
export const PRERENDER_ROUTES = [
  "/", "/pricing", "/schools", "/hr", "/agencies", "/construction", "/business",
  "/coaches", "/faq", "/blog", "/privacy", "/terms", "/contact",
  "/schedule-a-call", "/lead-form", "/staff-care-kit", "/sms-consent",
  ...blogPosts.map((post) => `/blog/${post.slug}`),
];

export function isPrerenderRoute(pathname: string): boolean {
  return PRERENDER_ROUTES.includes(pathname);
}
